import React, { Component } from "react";
import withAuthorization from "../../../components/Authorization/withAuthorization";
import Stepper from "react-stepper-horizontal";
import { Button, Modal } from "react-bootstrap";
import FullGuidebot from "../Tutorial_file/FullGuidebot.jsx";
import { fire, auth } from "../../../firebase/index";
import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    header: "Full Guide",
  },
  ja: {
    header: "完全ガイド",
  },
  es: {
    header: "Guía Completa",
  },
});

class FullGuidepdf extends Component {
  constructor() {
    super();
    this.state = {
      showPopup: false,
    };

    this.handlePopup = this.handlePopup.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  componentDidMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          localizationStrings.setLanguage(snapshot.val());
        });
    }
  }

  handlePopup() {
    this.setState({ showPopup: true });
  }

  handleClose() {
    this.setState({ showPopup: false });
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const modalStyle = {
      color: "black",
    };

    const buttonStyle = {
      backgroundColor: "#FFC500",
      color: "black",
      borderRadius: "5px",
      padding: "10px 20px",
      border: "none",
      cursor: "pointer",
    };

    const containerStyle = {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      width: "100%",
    };

    const modalDialogStyle = {
      maxWidth: "80%",
      width: "80%",
    };

    const shareLockStyle = {
      width: "100%",
      height: "auto",
    };

    return (
      <div style={containerStyle}>
        <button onClick={this.handlePopup} style={buttonStyle}>
          {localizationStrings.header}
        </button>
        <Modal
          show={this.state.showPopup}
          onHide={this.handleClose}
          style={modalStyle}
          dialogClassName="modal-90w"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                {localizationStrings.header}
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={containerStyle}>
              <FullGuidebot style={shareLockStyle} />
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default FullGuidepdf;
